<div class="ui modal Results_Modal"
     id="ResultModal">

  <ng-container *ngIf="this.resultModalSportradar">
    <div class="header">
      <span>{{"Results" | t}}</span>
      <button style="float:right;background-color: white;border: 1px solid;"
              class="circular ui icon button"
              (click)="ResultsModal_Close()">
        <i class="remove link icon"></i>
      </button>
    </div>
    <div class="iframe-content">
      <iframe [src]="iframesrc"
              width="100%"
              height="100%"></iframe>
    </div>
  </ng-container>

  <ng-container *ngIf="!this.resultModalSportradar">
    <div class="content">
      <table class="ui table">
        <tr>
          <td class="one wide">
            {{"Start" | t}}
          </td>
          <td class="three wide">
            {{"Home" | t}}
          </td>
          <td class="three wide">
            {{"Guest" | t}}
          </td>
          <td class="three wide">
            {{"League" | t}}
          </td>
          <td class="one wide">
            1.{{"half" | t}}
          </td>
          <td class="two wide">
            {{"Full_Time" | t}}
          </td>
          <button style="float:right;background-color: white;border: 1px solid; margin-right: 10px;
          margin-top: 3px;"
          class="circular ui icon button"
          (click)="ResultsModal_Close()">X</button>
        </tr>
      </table>

    </div>
    <div class="content"
         id="resultList"
         style="overflow: auto; height: 85%;">
      <table class="ui table">

        <ng-container *ngFor="let resultDay of this.tournamentsService.terminalResultList | groupByDate; let i = index">
          <tr>
            <td colspan="13"
                style="background-color:#D3D3E2">
              <span style="color:#000000;font-weight:bold">{{resultDay?.MatchGroupDate}}</span>
            </td>
          </tr>
          <ng-container *ngFor="let result of resultDay.events;let i = index;">
            <tr style="color:white">

              <td [ngStyle]="{'background-color': getBGColorResulModal(i)}"
                  class="one wide">
                {{result?.EventDate}}
              </td>
              <td [ngStyle]="{'background-color': getBGColorResulModal(i)}"
                  class="three wide">
                {{result?.HomeTeam}}
              </td>
              <td [ngStyle]="{'background-color': getBGColorResulModal(i)}"
                  class="three wide">
                {{result?.AwayTeam}}
              </td>
              <td [ngStyle]="{'background-color': getBGColorResulModal(i)}"
                  class="three wide">
                {{result?.TournamentName}}
              </td>
              <td [ngStyle]="{'background-color': getBGColorResulModal(i)}"
                  class="one wide">
                {{result?.HTScore}}
              </td>
              <td [ngStyle]="{'background-color': getBGColorResulModal(i)}"
                  class="two wide">
                {{result?.FTScore}}
              </td>


            </tr>
          </ng-container>
        </ng-container>
      </table>
    </div>
    <div class="extra content"
         id="sportcountrymodal_buttons">
      <div class="large ui buttons">
        <button class="ui button terminalButton"
                id="resultmodal_downbutton"
                (click)="Result_downScroll()"><i class="caret down icon"
                                                 style="position:relative;left:5px;"></i></button>
        <button class="ui button terminalButton"
                id="resultmodal_upbutton"
                (click)="Result_upScroll()"><i class="caret up icon"
                                               style="position:relative;left:5px;"></i></button>

      </div>


    </div>
  </ng-container>


</div>
<style>
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
</style>
